// src/components/PackageCard.tsx
import { Link } from 'react-router-dom';
import { Package, PackageLearning } from '../types';
import genericPackageImageUrl from '../assets/package-icon.svg';

interface PackageCardProps {
    pkg: PackageLearning;
}

function PackageCard({ pkg }: PackageCardProps) {
    return (
        // Dùng lại style của topic-card
        <div className="topic-card glass-effect">
            <img src={genericPackageImageUrl} alt={pkg.name} className="topic-image" />
            <div className="topic-info">
                <h3>{pkg.name}</h3>
                {/* --- KHỐI PROGRESS BAR MỚI --- */}
                <div className="topic-progress">
                    <div className="progress-bar-container">
                        <div
                            className="progress-bar"
                            style={{ width: `${pkg.progress}%` }}
                        ></div>
                    </div>
                    <span className="progress-label">{pkg.progress}%</span>
                </div>
                {/* --- KẾT THÚC KHỐI MỚI --- */}
                {/* <p>{pkg.description}</p> */}
                <div className="topic-actions">
                    <Link to={`/packages/${pkg.id}`} className="btn btn-primary" style={{ gridColumn: '1 / -1' }}>
                        Learn
                    </Link>
                </div>
            </div>

        </div>
    );
}

export default PackageCard;